import { render, staticRenderFns } from "./DocumentsModal.vue?vue&type=template&id=c3476e74&scoped=true&"
import script from "./DocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsModal.vue?vue&type=style&index=0&id=c3476e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3476e74",
  null
  
)

export default component.exports